import ProductList from './product-list.vue';
import Filters from './filters.vue';
import Grid from './grid.vue';
import LoadMore from './load-more-products.vue';

const install = (Vue) => {
  Vue.component(ProductList.name, ProductList);
  Vue.component(Filters.name, Filters);
  Vue.component(Grid.name, Grid);
  Vue.component(LoadMore.name, LoadMore);
};

export default {
  install,
};

export { ProductList, Filters, Grid, LoadMore };
